import immutableStore from 'utils/immutableStore';
import alt from 'components/Dispatcher';
import {Record, Map, List} from 'immutable';
import LiveCoachingActions from 'actions/scorecards/LiveCoachingActions';

const defaultState = {
  call: undefined, // unused?
  callLoading: false,
  createEmptyError: false,
  updateError: false,
  directions: List(),
  directionsError: false,
  coachId: undefined,
  recipientId: undefined,
  hasSubmittedScorecards: false,
  generalComments: undefined,
  callRecordingLink: undefined,
  liveCoachingReviews: Map(), // Map<CallId, CoachingReview?>
  liveCoachingReviewFileUploads: Map(), // Map<CallId, CoachingReviewFileupload?>
};

/**
 * Store to support Live Coaching.  The workflow mostly composes a call info drawer
 * with the usual scorecard components.  The main model is "call" here on the store.
 * To make the general comments work - we allow <Scorecard/> to take children to
 * essentially poke a hole down into that tree and save the general comments into this store.
 * (Separately, considering it goes to a different endpoint, etc)
 */
@immutableStore
class LiveCoachingStore {
  constructor() {
    this.state = Record(defaultState)();

    this.bindActions(LiveCoachingActions);
  }

  /**
   * We save an empty fileupload "metadata only" first - then later update it
   * based on the info the user chooses to fill in via the CallInfoDrawer
   *
   * @param recipientId
   * @param coachId
   */
  createEmpty([recipientId, coachId]) {
    this.setState({
      call: undefined,
      callLoading: true,
      createEmptyError: false,
      coachId,
      recipientId,
    });
  }

  createEmptySuccess(call) {
    this.setState({
      call,
      callLoading: false,
      createEmptyError: false,
    });
  }

  createEmptyError(e) {
    console.error(e);
    this.setState({
      callLoading: false,
      createEmptyError: true,
    });
  }

  /**
   * Save a flag that they've submitted at least one scorecard. If they haven't,
   * we pop up a warning when they try to submit the session.
   */
  scorecardSubmitted() {
    this.setState({
      hasSubmittedScorecards: true,
    });
  }

  /**
   * Update the metadata based on what the user provides in the call info drawer
   */
  update() {
    this.setState({
      callLoading: true,
      updateError: false,
    });
  }

  updateSuccess(call) {
    this.setState({
      call,
      callLoading: false,
      updateError: false,
    });
  }

  updateError(e) {
    console.error(e);
    this.setState({
      callLoading: false,
      updateError: true,
    });
  }

  /**
   * Api call to get directions eg INBOUND, OUTBOUND..
   * (some accounts/departments customize these)
   */
  directions() {
    this.setState({
      directions: List(),
    });
  }

  directionsSuccess(directions) {
    this.setState({
      directions,
    });
  }

  directionsError(e) {
    console.error(e);
    this.setState({
      directions: List(),
    });
  }

  setGeneralComments(generalComments) {
    this.setState({generalComments});
  }

  setCallRecordingLink(link) {
    const callRecordingLink = link && link.trim();
    this.setState({callRecordingLink});
  }

  retrieveForCallSuccess([callId, coachingReview]) {
    this.setState({
      liveCoachingReviews: this.state.liveCoachingReviews.set(callId, coachingReview),
    });
  }

  retrieveForCallError(error) {
    console.error(error);
  }

  reset() {
    this.setState(defaultState);
  }
}

export default alt.createStore(LiveCoachingStore, 'LiveCoachingStore');
